import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Label } from './ui/label.jsx';
import { Input } from './ui/input.jsx';
import { Button } from './ui/button.jsx';

const AdvancedSection = ({ advanced, setAdvanced, onSaveDefaults, onApplyDefaults }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (field, value) => {
    setAdvanced(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="bg-white rounded-lg shadow-lg mb-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 sm:p-6 flex items-center justify-between hover:bg-gray-50 transition-colors"
        data-testid="advanced-toggle"
      >
        <h2 className="text-xl font-semibold text-gray-800">Advanced Settings</h2>
        {isExpanded ? (
          <ChevronUp className="w-5 h-5 text-gray-600" />
        ) : (
          <ChevronDown className="w-5 h-5 text-gray-600" />
        )}
      </button>
      
      {isExpanded && (
        <div className="p-4 sm:p-6 pt-0 border-t">
          <div className="space-y-4 mb-4">
            <div>
              <Label htmlFor="ntp-server">NTP Server</Label>
              <Input
                id="ntp-server"
                value={advanced.ntp_server}
                onChange={(e) => handleChange('ntp_server', e.target.value)}
                placeholder="time.nist.gov"
                data-testid="ntp-server"
              />
            </div>
            <div>
              <Label htmlFor="http-port">HTTP Port</Label>
              <Input
                id="http-port"
                value={advanced.http_port}
                onChange={(e) => handleChange('http_port', e.target.value)}
                placeholder="80"
                data-testid="http-port"
              />
            </div>
            <div>
              <Label htmlFor="https-port">HTTPS Port</Label>
              <Input
                id="https-port"
                value={advanced.https_port}
                onChange={(e) => handleChange('https_port', e.target.value)}
                placeholder="443"
                data-testid="https-port"
              />
            </div>
            <div>
              <Label htmlFor="custom-param">Custom Parameter</Label>
              <Input
                id="custom-param"
                value={advanced.custom_param}
                onChange={(e) => handleChange('custom_param', e.target.value)}
                placeholder="Custom configuration"
                data-testid="custom-param"
              />
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 pt-4 border-t">
            <Button
              onClick={onSaveDefaults}
              variant="outline"
              size="sm"
              className="w-full sm:w-auto"
              data-testid="save-defaults-btn"
            >
              Save as Defaults
            </Button>
            <Button
              onClick={onApplyDefaults}
              variant="outline"
              size="sm"
              className="w-full sm:w-auto"
              data-testid="apply-defaults-btn"
            >
              Apply Defaults
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedSection;